import { type UseQueryResult } from '@tanstack/react-query'
import { type PrismicError, dhlExtraPromotionOneOffType } from '../model/prismic.js'
import { useGetPrismicPromotions } from './useGetPrismicPromotions.js'

type Params = {
  prismicEndpoint: string
}

export const useGetPrismicOneOffPromotionUids = ({ prismicEndpoint }: Params): UseQueryResult<string[], PrismicError> =>
  useGetPrismicPromotions(
    {
      prismicEndpoint,
      lang: '*',
    },
    {
      query: {
        queryKey: [`${prismicEndpoint}/${dhlExtraPromotionOneOffType}/uids`],
      },
    }
  ) as unknown as UseQueryResult<string[], PrismicError>
